import axios from "axios";

export const addToWishlist = async (job_id, userid, getAllWishlist) => {
  const Wishlist = { userid: userid, job_id: job_id, isactive: 1 };
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}job_wishlist/createjobwishlist`,
      Wishlist
    );
    return response.data; 
  } catch (error) {
    console.error("Error adding to wishlist:", error);
    throw error; 
  }
};
export const removeFromWishlist = async (userid,job_id) => {
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_API_URL}job_wishlist/removefromwishlist/${userid}/${job_id}`
    );
    return response.data; 
  } catch (error) {
    console.error("Error removing from wishlist:", error);
    throw error; 
  }
};

export const getAllWishlist = async (userid) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}job_wishlist/getwishlistbyuserid/${userid}`
    );
    return response.data.data; 
  } catch (error) {
    console.error("Error fetching wishlist:", error);
    throw error; 
  }
};


